const GRID_VIEW = 'grid';
const TABLE_VIEW = 'table';

export enum EView {
  grid = GRID_VIEW,
  table = TABLE_VIEW,
}
